"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.topBuildingGalleryScrollListener = exports.setBuildingTopGalleryScroll = void 0;
var redux_saga_1 = require("redux-saga");
var debounce_1 = require("@/utils/debounce");
var setBuildingTopGalleryScroll = function (index, total, noSmooth) {
    if (noSmooth === void 0) { noSmooth = false; }
    if (!window)
        return;
    {
        var slideContainer = document.getElementById('buildingTopGallery');
        if (!slideContainer)
            return;
        var slideItemWidth = slideContainer.clientWidth;
        var finalIndex = index === -1 ? total : index;
        if (slideContainer.scroll) {
            slideContainer.scroll({
                left: slideItemWidth * finalIndex,
                behavior: noSmooth ? 'auto' : 'smooth',
            });
        }
        else {
            slideContainer.scrollLeft = slideItemWidth * finalIndex;
        }
    }
};
exports.setBuildingTopGalleryScroll = setBuildingTopGalleryScroll;
var topBuildingGalleryScrollListener = function () {
    return redux_saga_1.eventChannel(function (emit) {
        var slideContainer = document.getElementById('buildingTopGallery');
        var scrollChangedListener = function () {
            var x = slideContainer.scrollLeft;
            var w = slideContainer.clientWidth;
            var index = Math.floor((x + 1) / w);
            emit({ index: index });
        };
        var listener = debounce_1.debounce(scrollChangedListener, 200);
        slideContainer.addEventListener('scroll', listener);
        return function () {
            slideContainer.removeEventListener('scroll', scrollChangedListener);
        };
    });
};
exports.topBuildingGalleryScrollListener = topBuildingGalleryScrollListener;
